<h2 mat-dialog-title class="dialog-title">Raum bearbeiten</h2>
<mat-dialog-content class="mat-typography dialog-content">
  <form [formGroup]="frmRaum">
    <div class="form-group">
      <input type="hidden" formControlName="sektion_id" />
    </div>
    <div class="form-group">
      <label class="form-label" for="name">Raum Name</label>
      <input type="text" class="form-control" id="name" formControlName="name" placeholder="Raum Name eingeben" />
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button *ngIf="isInactive()" (click)="onRestore()">Wiederherstellen</button>
  <button mat-button *ngIf="!isInactive()" color="warn" (click)="onDelete()">Löschen</button>
  <button mat-button (click)="onDismiss()">Abbrechen</button>
  <button mat-button (click)="onConfirm()" cdkFocusInitial>Speichern</button>
</mat-dialog-actions>

